module.exports = __webpack_public_path__ + "static/img/Bitmap.4a4bc3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homes/Bitmap.png
// module id = kUi8
// module chunks = 1